<template>
  <div class="hero">
    <div class="hero_content">
      <h1>Doggie care services for your lovable fur friends</h1>
      <p>
        No need to leave your pets feeling lonely at home while you’re away. Our
        Certified Caregivers can come to your home to give your pets specialized
        care and keep them company.
      </p>
      <button class="hero_content_btn">
        <a href="#">Explore Our Services</a>
      </button>
    </div>
    <div class="hero_img">
      <img src="../assets/images/hero-bgg.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",
};
</script>

<style lang="scss" src="../styles/hero.scss"></style>
